import { render } from "./ManageNotifications.vue?vue&type=template&id=4e21275e&scoped=true"
import script from "./ManageNotifications.vue?vue&type=script&lang=js"
export * from "./ManageNotifications.vue?vue&type=script&lang=js"

import "./ManageNotifications.vue?vue&type=style&index=0&id=4e21275e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e21275e"]])

export default __exports__